import { Dialog } from '@monorepo/nova-ui';
import { IconButton, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: theme.customShape.borderRadius5XL,
    padding: theme.spacing(12),
    maxWidth: theme.spacing(163),
    width: '100%',
    overflow: 'visible',
    boxShadow: '0px 144px 250px 0px rgba(221, 253, 108, 0.2)',

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(6),
      borderRadius: theme.customShape.borderRadius3XL,
      overflow: 'auto',
    },
  },
  '& .MuiDialog-paperWidthFalse': {
    maxWidth: theme.spacing(163),
  },
}));

export const StyledModalBody = styled(Stack)(({ theme }) => ({
  position: 'relative',
  alignItems: 'center',
  textAlign: 'center',
  gap: theme.spacing(6),
}));

export const StyledWarningIconContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  borderRadius: theme.customShape.borderRadiusLarge,
  transform: 'rotate(45deg)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: theme.spacing(3),

  '& > *': {
    transform: 'rotate(-45deg)',
  },
}));

export const StyledTextGroup = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  alignItems: 'center',
}));

export const StyledActionsRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(6),
  width: '100%',

  '& > *': {
    flex: 1,
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(3),

    '& > *': {
      flex: 'none',
      width: '100%',
    },
  },
}));

export const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  padding: theme.spacing(1),
}));
